import axios from "axios";

export default function DocumenttypeShowService(id) {
  return axios({
    method: 'get',
    url: process.env.REACT_APP_API_HOST + "/document-type/" + id,
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
